@let hasDocument = documentsLength() !== 0;

<button
	(click)="!hasDocument ? onAdd() : null"
	class="card-frame bg-neutral-50 dark:bg-neutral-900"
	[class]="hasDocument ? '' : 'hover-layer'">
	@if (hasDocument) {
		<app-state-badge large [ultraToolTip]="" [state]="stateBadgeEnum.SUCCESS" />
		<div class="flex gap-2">
			<ng-content></ng-content>
		</div>
	} @else {
		<app-state-badge large [state]="stateBadgeEnum.WARNING" />
		{{ emptyString() | transloco }}
	}
</button>
